<template>
  <div class="admin-layout">
    <NavBar />
    <div class="dashboard-layout">
      <AdminDrawer :activeMenu="activeMenu" />
      <main class="main-content">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import AdminDrawer from "@/components/admin/AdminDrawer.vue";

export default {
  name: "AdminLayout",
  components: {
    NavBar,
    AdminDrawer,
  },
  computed: {
    activeMenu() {
      // Extract the active menu from the route
      const path = this.$route.path;
      if (path.includes("/admin/clients")) return "clients";
      if (path.includes("/admin/provisioning")) return "provisioning";
      if (path.includes("/admin/investments")) return "investments";
      if (path.includes("/admin/reports")) return "reports";
      if (path.includes("/admin/settings")) return "settings";
      return "dashboard";
    },
  },
};
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.dashboard-layout {
  display: flex;
  min-height: calc(100vh - 80px); /* Adjust for navbar height */
}

.main-content {
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
}
</style>
